import { render, staticRenderFns } from "./FavoritePage.vue?vue&type=template&id=65824f49&scoped=true"
import script from "./FavoritePage.vue?vue&type=script&lang=js"
export * from "./FavoritePage.vue?vue&type=script&lang=js"
import style0 from "./FavoritePage.vue?vue&type=style&index=0&id=65824f49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65824f49",
  null
  
)

export default component.exports